import {MarkupNodeType} from '#src/constants.js';
import {createHtmlTag} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

const TAG_MAP = new Map([
  ['---', MarkupNodeType.Strikethrough],
  ['***', MarkupNodeType.Underlined],
  ['**', MarkupNodeType.Bold],
  ['*', MarkupNodeType.Italics],
  ['___', MarkupNodeType.Underlined],
  ['__', MarkupNodeType.Bold],
  ['_', MarkupNodeType.Italics],
  ['///', MarkupNodeType.Italics],
  ['%%%', MarkupNodeType.CollapsibleSpoiler],
  ['%%', MarkupNodeType.Spoiler],
  ['[b]', MarkupNodeType.Bold],
  ['[i]', MarkupNodeType.Italics],
  ['[s]', MarkupNodeType.Strikethrough],
  ['[u]', MarkupNodeType.Underlined],
  ['[sub]', MarkupNodeType.Subscript],
  ['[sup]', MarkupNodeType.Superscript],
  ['[spoiler]', MarkupNodeType.Spoiler]
]);

const convertTags = (isMarkdown, variant) => ({matchStart, options, text}) => {
  options.skipType = SkipType.NoSkip;

  const nodeType = TAG_MAP.get(matchStart[0]);

  if (!nodeType) {
    return '';
  }

  options.op = createHtmlTag(nodeType, {}, {isMarkdown, variant, isNonClosing: true});
  options.cl = '</div>';

  return text;
};

export default [{
  convert: convertTags(true),
  op: '---',
  priority: 2500
}, {
  convert: convertTags(true, 'asterisk'),
  op: '***',
  priority: 2700
}, {
  convert: convertTags(true, 'asterisk'),
  op: '**',
  priority: 2800
}, {
  convert: convertTags(true, 'asterisk'),
  op: '*',
  priority: 2900
}, {
  convert: convertTags(true, 'underscore'),
  op: '___',
  priority: 3000
}, {
  convert: convertTags(true, 'underscore'),
  op: '__',
  priority: 3100
}, {
  convert: convertTags(true, 'underscore'),
  op: '_',
  priority: 3200
}, {
  convert: convertTags(true, 'slash'),
  op: '///',
  priority: 3300
}, {
  convert: convertTags(true),
  op: '%%%',
  priority: 3400
}, {
  convert: convertTags(true),
  op: '%%',
  priority: 3500
}, {
  cl: '[/b]',
  convert: convertTags(false),
  nestable: true,
  op: '[b]',
  priority: 3600
}, {
  cl: '[/i]',
  convert: convertTags(false),
  nestable: true,
  op: '[i]',
  priority: 3700
}, {
  cl: '[/s]',
  convert: convertTags(false),
  nestable: true,
  op: '[s]',
  priority: 3800
}, {
  cl: '[/u]',
  convert: convertTags(false),
  nestable: true,
  op: '[u]',
  priority: 3900
}, {
  cl: '[/sub]',
  convert: convertTags(false),
  nestable: true,
  op: '[sub]',
  priority: 4000
}, {
  cl: '[/sup]',
  convert: convertTags(false),
  nestable: true,
  op: '[sup]',
  priority: 4100
}, {
  cl: '[/spoiler]',
  convert: convertTags(false),
  nestable: true,
  op: '[spoiler]',
  priority: 4200
}];
